module.exports = __webpack_public_path__ + "img/total.677b669d.svg";